import script from "./CategoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryCard.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryCard.vue?vue&type=style&index=0&id=45a62fb8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a62fb8"]])

export default __exports__